import BaseModel from "nexia_mobile/models/base_model";

export default class Geofence extends BaseModel {
  defaults() {
    return {
      name: "New Geofence",
      latitude: 0,
      longitude: 0,
      radius: 10000,
    };
  }

  onParse(attrs) {
    this.set("hrefAcknowledge", null);
    return super.onParse(attrs);
  }

  parseLinksAcknowledge(links) {
    let link = _.first(links);
    if (link == null) {
      return;
    }
    this.set("hrefAcknowledge", link.href);
  }

  parseLinksOperation(links) {
    _.each(links, (link) => {
      if (link.title.match(/enter/i)) {
        this.set("hrefEnter", link.href);
      } else if (link.title.match(/exit/i)) {
        this.set("hrefExit", link.href);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/models/geofence.js